import { render, staticRenderFns } from "./WithdrawCryptoExchangeForm.vue?vue&type=template&id=4fe3ffbc&scoped=true"
import script from "./WithdrawCryptoExchangeForm.vue?vue&type=script&lang=js"
export * from "./WithdrawCryptoExchangeForm.vue?vue&type=script&lang=js"
import style0 from "./WithdrawCryptoExchangeForm.vue?vue&type=style&index=0&id=4fe3ffbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe3ffbc",
  null
  
)

export default component.exports